import { CollapsableFormZone } from 'components/Form/CollapsableFormZone/CollapsableFormZone';
import { ChipListInput } from 'components/Inputs/ChipListInput/ChipListInput';
import { SelectInput } from 'components/Inputs/SelectInput/SelectInput';
import { AGING_DATE_BASIS } from 'services/api/legalCorporationConfig/types';

import { FormRowContainer } from '../SettingsForm.style';
import { isPositiveInteger, SettingsFormKeys } from '../settingsFormValues';
import {
  getListError,
  SettingsSectionProps,
  useSettingsFieldHelpers,
} from '../useSettingsFieldHelpers';

export const AccountBalanceSection = ({
  formik,
  isReadOnly,
}: SettingsSectionProps): JSX.Element => {
  const { settingsFormIntl } = useSettingsFieldHelpers(formik, isReadOnly);

  const agingBucketsError = getListError(formik.errors[SettingsFormKeys.AGING_BUCKETS]);

  return (
    <CollapsableFormZone title={settingsFormIntl('sections.account-balance')}>
      <>
        <FormRowContainer>
          <ChipListInput
            id={SettingsFormKeys.AGING_BUCKETS}
            label={settingsFormIntl('form.aging-buckets.label')}
            placeholder={settingsFormIntl('form.aging-buckets.placeholder')}
            values={formik.values[SettingsFormKeys.AGING_BUCKETS].map(String)}
            onChange={(buckets) =>
              formik.setFieldValue(
                SettingsFormKeys.AGING_BUCKETS,
                Array.from(new Set(buckets.map(Number))).sort((a, b) => a - b),
              )
            }
            isValidEntry={isPositiveInteger}
            invalidEntryMessage={settingsFormIntl('form.aging-buckets.invalid')}
            error={Boolean(agingBucketsError)}
            helperText={agingBucketsError}
            disabled={isReadOnly}
            required
          />
        </FormRowContainer>
        <FormRowContainer>
          <SelectInput
            id={SettingsFormKeys.AGING_DATE_BASIS}
            name={SettingsFormKeys.AGING_DATE_BASIS}
            label={settingsFormIntl('form.aging-date-basis.label')}
            value={formik.values[SettingsFormKeys.AGING_DATE_BASIS]}
            onChange={formik.handleChange}
            choices={AGING_DATE_BASIS.map((basis) => ({
              label: settingsFormIntl(`form.aging-date-basis.${basis}`),
              value: basis,
            }))}
            disabled={isReadOnly}
            required
          />
        </FormRowContainer>
      </>
    </CollapsableFormZone>
  );
};
